require('../../styles/blocks/_documentation-info.scss');

//@vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
//@utilities
import { FormattedText } from 'core/i18n';
//@actions
const formActions = require('react-redux-form').actions;
const cardImagesActions = require('actions/cardImagesActions');

class AuthorizedCreditCard extends React.Component {
    getItemCard() {
        const { openCreditCMSJaffar, scorings } = this.props;
        const ml2 = scorings.getIn(['ml2', 'scoringStatus']) === 'approved';
        const jaffar = scorings.getIn(['jaffar', 'scoringStatus']) === 'approved';
        let result = '';
        if (!ml2 && !jaffar) {
            result = <li style={{ maxWidth: 800, marginRight: -214 }}>{openCreditCMSJaffar}</li>;
        }

        return result;
    }

    getTitle() {
        const { scorings, userProfile } = this.props;
        const ml2 = scorings.getIn(['ml2', 'scoringStatus']) === 'approved';
        const jaffar = scorings.getIn(['jaffar', 'scoringStatus']) === 'approved';
        const pensionista = '04';

        let formattedProps = {
            value: 'cardInfo-titleScoringDisapproved',
        };

        if (ml2) {
            const openCreditLimit = scorings.getIn(['ml2', 'cardLimit']);
            formattedProps.value = 'cardInfo-titleScoring';
            formattedProps.injectedStrings = [openCreditLimit];
        } else if (jaffar) {
            const openCreditLimit = scorings.getIn(['jaffar', 'cardLimit']);
            formattedProps.value = 'cardInfo-titleScoring';
            formattedProps.injectedStrings = [openCreditLimit];
        } else if (userProfile.accountType === pensionista) {
            const openCreditLimit = scorings.getIn(['jaffar', 'cardLimit']);
            formattedProps.value = 'cardInfo-titleScoring';
            formattedProps.injectedStrings = [openCreditLimit];
        } else {
            const openCreditLimit = scorings.getIn(['jaffar', 'cardLimit']);
            formattedProps.injectedStrings = [openCreditLimit];
        }

        return <FormattedText {...formattedProps} />;
    }

    render() {
        const { userProfile } = this.props;
        const imageCard = userProfile.cardImageUrl;
        const itemCard = this.getItemCard();
        const title = this.getTitle();
        const informationText = 'cardInfo-information';

        return (
            <div>
                <div className="card-info">
                    <section>
                        <div className="row">
                            <div className="col-xs-12 col-sm-8 card-info__block">
                                <div>
                                    <h5>{title}</h5>
                                    <span className="dash-blue"></span>
                                    <div className="products-list__single-list">
                                        <ul>
                                            <FormattedText value={informationText} />
                                            {itemCard}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4 card-info__image">
                                <img src={imageCard} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </section>
                </div>
                <div className="documentation-info-view__divider"></div>
            </div>
        );
    }
}

module.exports.constructor = AuthorizedCreditCard;
module.exports.AuthorizedCreditCard = connect(
    state => ({
        userProfile: state.userProfile,
        cardImages: state.cardImages,
        scorings: state.scorings,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        cardImagesActions: bindActionCreators(cardImagesActions, dispatch),
    })
)(AuthorizedCreditCard);
